import { LongErrorStackPromise } from './LongErrorStackPromise';

/**
 * This promise will maintain stack traces in errors that new Promise() won't
 */
let doLongStackTraces: boolean;

if (
	['TRUE', 'YES', 'T', 'Y', '1'].includes(process.env['LONG_STACK_TRACES']?.toUpperCase() ?? '')
) {
	doLongStackTraces = true;
} else if (
	['FALSE', 'NO', 'F', 'N', '0'].includes(process.env['LONG_STACK_TRACES']?.toUpperCase() ?? '')
) {
	doLongStackTraces = false;
} else if (process.env['NODE_ENV'] === 'development' || process.env['NODE_ENV'] === 'test') {
	doLongStackTraces = true;
} else if (process.env['NODE_ENV'] === 'production') {
	doLongStackTraces = false;
} else {
	doLongStackTraces = true;
}

// type Executor1 = (resolve: () => void, reject: (reason?: any) => void) => void;
type Executor<T> = (
	resolve: (value: T | PromiseLike<T>) => void,
	reject: (reason?: any) => void
) => void;
// type Executor<T> = Executor2<T> | Executor1;

export function makePromise<T>(executor: Executor<T>, extraStackSlice = 0): Promise<T> {
	if (doLongStackTraces) {
		return new LongErrorStackPromise(executor, extraStackSlice);
	} else {
		return new Promise(executor);
	}
}

export function fixErrorStack<T>(promise: Promise<T>): Promise<T> {
	const promise2 = makePromise<T>((resolve, reject) => {
		promise.then(resolve, reject);
	}, 2);

	return promise2;
}
